WL.registerComponent('lists-controller', {
    list1Object: { type: WL.Type.Object },
    list2Object: { type: WL.Type.Object },
    list3Object: { type: WL.Type.Object },
    
    sack1Object: { type: WL.Type.Object },
    sack2Object: { type: WL.Type.Object },
    sack3Object: { type: WL.Type.Object },
}, {
    init: function () {
        this.list1 = this.list1Object.getComponent('list-controller');
        this.list2 = this.list2Object.getComponent('list-controller');
        this.list3 = this.list3Object.getComponent('list-controller');
        
        this.sack1 = this.sack1Object.getComponent('mesh');
        this.sack2 = this.sack2Object.getComponent('mesh');
        this.sack3 = this.sack3Object.getComponent('mesh');
    },

    setWishes: function (wishes) {
        this.list1.setGifts(wishes[2], wishes[5]);        
        this.list2.setGifts(wishes[0], wishes[3]);
        this.list3.setGifts(wishes[1], wishes[4]);
        
        this.sack1.active = !!wishes[2];
        this.sack2.active = !!wishes[0];
        this.sack3.active = !!wishes[1];        
    },

    start: function () {
       
    },

    update: function (dt) {

    },
});
